export default {
  // Nav
  'nav.home': 'Accueil',
  'nav.guide': 'Guide',
  'nav.shoppingGuide': "Guide d'achat",
  'nav.categories': 'Catégories',
  'nav.safety': 'Sécurité',
  'nav.brand': 'USFans Spreadsheet',

  // Hero
  'hero.eyebrow': 'LE HUB DE RESSOURCES USFANS SPREADSHEET',
  'hero.title': 'USFans Spreadsheet — trouvez, organisez et explorez les infos des créateurs',
  'hero.subtitle':
    'Découvrez des ressources pratiques de tableurs USFans, des guides de créateurs, des comparaisons, des informations de sécurité et des outils utiles conçus pour rendre la recherche de créateurs plus rapide, plus claire et plus facile à organiser.',
  'hero.ctaPrimary': 'usfans spreadsheet',
  'hero.ctaSecondary': 'achetez maintenant',
  'hero.trust': 'Ressource indépendante · Guides pratiques · Axé sécurité · Mis à jour régulièrement',

  // Category section
  'category.title': 'Explorez par catégorie',
  'category.subtitle':
    "Accédez directement à la section exacte de la boutique dont vous avez besoin. Choisissez une catégorie ci-dessous ou utilisez le menu déroulant pour naviguer rapidement.",
  'category.dropdownLabel': 'Sélectionnez une catégorie',
  'category.browseAll': 'Parcourir tout le catalogue de la boutique',
  'category.featured': 'Catégories populaires',

  // What is section
  'what.title': "Qu'est-ce qu'un tableur USFans ?",
  'what.p1':
    "Un tableur USFans est une façon structurée d'organiser les informations sur les créateurs au même endroit. Au lieu de chercher dans des pages dispersées, les utilisateurs peuvent utiliser des ressources organisées sous forme de tableur pour rechercher, comparer et gérer les informations plus efficacement.",
  'what.p2':
    "Notre hub de ressources USFans Spreadsheet rassemble des guides pratiques, des comparaisons, des ressources de sécurité et du contenu éducatif pour aider les utilisateurs à comprendre comment ces ressources fonctionnent et comment les utiliser de façon responsable.",
  'what.cta': 'Explorer le guide USFans Spreadsheet',

  // Benefits
  'benefit.title': 'Pourquoi utiliser un tableur USFans ?',
  'benefit.subtitle': 'Des avantages pratiques qui rendent la recherche organisée plus simple et plus fiable.',
  'benefit.1.title': 'Recherche organisée',
  'benefit.1.desc': 'Gardez les informations pertinentes sur les créateurs structurées et plus faciles à consulter.',
  'benefit.2.title': 'Découverte plus rapide',
  'benefit.2.desc': 'Utilisez des ressources organisées au lieu de dépendre uniquement de recherches dispersées.',
  'benefit.3.title': 'Comparaison plus facile',
  'benefit.3.desc': 'Comparez différentes sources avec des tableaux clairs et des guides structurés.',
  'benefit.4.title': 'Meilleures décisions',
  'benefit.4.desc': 'Comprenez ce que signifie une information avant de vous y fier.',

  // Articles
  'articles.title': 'Derniers guides USFans Spreadsheet',
  'articles.subtitle':
    'Des guides originaux et pratiques pour comprendre, organiser et utiliser les ressources de tableur en toute sécurité.',
  'articles.readTime': '{{minutes}} min de lecture',
  'articles.updated': 'Mis à jour',
  'articles.readMore': "Lire l'article",
  'articles.related': 'Guides associés',

  // Comparison
  'comparison.title': 'USFans Spreadsheet vs autres méthodes de découverte',
  'comparison.subtitle': "Voyez comment les ressources organisées se comparent aux autres façons de rechercher.",
  'comparison.method': 'Méthode',
  'comparison.organization': 'Organisation',
  'comparison.searchability': 'Recherchabilité',
  'comparison.compare': 'Comparaison',
  'comparison.bestFor': 'Idéal pour',
  'comparison.row1.name': 'USFans Spreadsheet',
  'comparison.row2.name': 'Recherche manuelle',
  'comparison.row3.name': 'Annuaire de créateurs',
  'comparison.row4.name': 'Listes non structurées',
  'comparison.high': 'Élevée',
  'comparison.medium': 'Moyenne',
  'comparison.low': 'Faible',
  'comparison.row1.best': 'Recherche organisée',
  'comparison.row2.best': 'Recherches rapides',
  'comparison.row3.best': 'Navigation',
  'comparison.row4.best': 'Référence de base',
  'comparison.cta': 'Voir la comparaison complète',

  // Safety
  'safety.title': 'Restez en sécurité avec les ressources de tableur en ligne',
  'safety.subtitle': 'Quelques habitudes simples protègent vos données et votre tranquillité.',
  'safety.p1':
    "Ne partagez jamais de mots de passe ni d'informations sensibles avec des sites inconnus. Vérifiez les liens avant de les ouvrir, évitez les téléchargements suspects et traitez avec prudence les listes de créateurs ou affirmations non vérifiées.",
  'safety.1': 'Vérifiez les liens avant de cliquer',
  'safety.2': 'Ne partagez jamais de mots de passe',
  'safety.3': 'Évitez les téléchargements suspects',
  'safety.4': 'Remettez en question les affirmations non vérifiées',
  'safety.cta': 'Visiter le Centre de sécurité',

  // Final CTA
  'final.title': 'Prêt à explorer les ressources USFans Spreadsheet ?',
  'final.subtitle':
    "Commencez par le guide complet USFans Spreadsheet, puis explorez les ressources de créateurs, les comparaisons et les informations de sécurité conçues pour rendre votre recherche plus organisée.",
  'final.cta': 'Explorer USFans Spreadsheet',

  // Footer
  'footer.tagline':
    'Une ressource informative indépendante sur les guides, comparaisons et informations de sécurité USFans Spreadsheet.',
  'footer.resources': 'Ressources',
  'footer.explore': 'Explorer',
  'footer.legal': 'Mentions légales',
  'footer.disclaimer':
    "USFanslink.makeup est une ressource informative indépendante. Les informations peuvent changer, les sites tiers peuvent modifier leurs politiques et les utilisateurs doivent vérifier les informations importantes par eux-mêmes.",
  'footer.rights': 'Tous droits réservés.',
  'footer.store': 'Visiter la boutique',

  // Categories
  'categories.shoes': 'Chaussures',
  'categories.hoodies': 'Hoodies/Sweats',
  'categories.tshirts': 'T-shirts',
  'categories.jackets': 'Vestes',
  'categories.pants': 'Pantalons/Shorts',
  'categories.headwear': 'Couvre-chefs',
  'categories.sets': 'Ensembles',
  'categories.underwear': 'Sous-vêtements',
  'categories.jersey': 'Maillots',
  'categories.accessories': 'Accessoires',
  'categories.bags': 'Sacs',
  'categories.belts': 'Ceintures',
  'categories.perfumes': 'Parfums',
  'categories.other': 'Autres articles',
};